import { Routes, Route, Navigate } from 'react-router-dom';
import { PublicRoutes } from './PublicRoutes';
import { PrivateRoutes } from './PrivateRoutes';
import { LoginPage } from '~/pages/auth/LoginPage';
import { HomePage } from '~/pages/home/HomePage';
import { PublicLayout } from '~/layouts/PublicLayout';
import { ROUTES } from '~/utils/constants';

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path={ROUTES.HOME}
        element={
          <PublicLayout>
            <HomePage />
          </PublicLayout>
        }
      />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/app/*" element={<PrivateRoutes />} />
      <Route path="/public/*" element={<PublicRoutes />} />
      <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
    </Routes>
  );
}
